/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Kind_Warmup_HintInputs */

const en_us2_workout_logging_kind_warmup_hint = /** @type {(inputs: Workout_Logging_Kind_Warmup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A light load to prepare the movement. Counts toward neither volume nor records.`)
};

const pt_br2_workout_logging_kind_warmup_hint = /** @type {(inputs: Workout_Logging_Kind_Warmup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga leve para preparar o movimento. Não conta no volume nem nos recordes.`)
};

const es_419_workout_logging_kind_warmup_hint = /** @type {(inputs: Workout_Logging_Kind_Warmup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso ligero para preparar el movimiento. No cuenta para el volumen ni para los récords.`)
};

const pt_pt2_workout_logging_kind_warmup_hint = /** @type {(inputs: Workout_Logging_Kind_Warmup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga leve para preparar o movimento. Não conta para o volume nem para os recordes.`)
};

const fr_fr2_workout_logging_kind_warmup_hint = /** @type {(inputs: Workout_Logging_Kind_Warmup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une charge légère pour préparer le mouvement. Ne compte ni dans le volume ni dans les records.`)
};

const de_de2_workout_logging_kind_warmup_hint = /** @type {(inputs: Workout_Logging_Kind_Warmup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leichtes Gewicht, um die Bewegung vorzubereiten. Zählt weder für Volumen noch für Rekorde.`)
};

const it_it2_workout_logging_kind_warmup_hint = /** @type {(inputs: Workout_Logging_Kind_Warmup_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un carico leggero per preparare il movimento. Non conta né per il volume né per i record.`)
};

/**
* | output |
* | --- |
* | "A light load to prepare the movement. Counts toward neither volume nor records." |
*
* @param {Workout_Logging_Kind_Warmup_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_kind_warmup_hint = /** @type {((inputs?: Workout_Logging_Kind_Warmup_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Kind_Warmup_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_kind_warmup_hint(inputs)
	if (locale === "es-419") return es_419_workout_logging_kind_warmup_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_kind_warmup_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_kind_warmup_hint(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_kind_warmup_hint(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_kind_warmup_hint(inputs)
	return en_us2_workout_logging_kind_warmup_hint(inputs)
});
export { workout_logging_kind_warmup_hint as "workout-logging.kind_warmup_hint" }